<template>
    <div @click="closeFilters()" class="filters-page">
        <div v-on:click.stop class="filters-page-container">
            <div class="filter-header">
                <p>Filters</p>
                <img @click="closeFilters()" class="x" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x"/>
            </div>
            <div class="filters-container">
                <CardsFilter :occasions="occasionFilters"/>
            </div>
            <div class="button-container">
                <button @click="resetFilters" class="happybox-button white border">Reset</button>
                <button @click="applyFilters" class="happybox-button green border">Apply</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CardsFilter from './Filters/CardsFilter.vue'
export default {
    components: {
        CardsFilter
    },
    data() {
        return{
        }
    },
    props:{
        occasionFilters: Array
    },
    computed: {
        ...mapGetters([
            'selectedCardsOccasions',
            'selectedCardsOccasionsMobile'
        ])
    },
    methods: {
        closeFilters(){
            //Reset the mobile filters to the true filters
            this.$store.commit('setAllSelectedCardOccasionMobile', JSON.parse(JSON.stringify(this.selectedCardsOccasions)))
            this.$emit("closefilter");
        },
        resetFilters(){
            this.$store.commit('setAllSelectedCardOccasion', ["View All"])
            this.closeFilters();
        },
        applyFilters(){
            //Change the mobile filters to the true filters
            this.$store.commit('setAllSelectedCardOccasion', JSON.parse(JSON.stringify(this.selectedCardsOccasionsMobile)))
            this.$emit("closefilter");
        },
    }
}
</script>

<style scoped>
.filters-page{
    width: 100%;
    height: 100%;
    position: fixed;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 5;
    transition: height 0.5s;
    display: flex;
    justify-content: flex-end;
}
.filters-page-container{
    width: 75%;
    max-height: 100%;
    min-height: 100%;
    height: 100%;
    background-color: white;
    overflow-y: scroll;
    padding-bottom: 17%;
}

.filters-container{
    padding: 0% 5% 5% 5%;
}

.filter-header{
    box-shadow: inset 0px -1px 0px #e6e8ec;
    display: flex;
    padding: 5%;
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
    justify-content: space-between;
    align-items: center;
}

.filter-header p{
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    color: #000000;
}

.filter-header button{
    font-size: 25px;
    line-height: 1;
    color: black;
    padding-right: 5%;
    z-index: 1;
}



.product-sort{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    box-shadow: inset 0px -1px 0px #E6E8EC;
    padding: 5% 0%;
}

.product-sort span{
    font-weight: bold;
    font-size: 1.1rem;
    line-height: 1.3;
    color: #0F0C38;
}

.product-sort select{
    width: 65%;
    padding: 2% 8% 2% 2%;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    border-radius: 100px;
    font-size: 1rem;
    line-height: 1.3;
    color: #0F0C38;
    height: unset;
}

.button-container{
   width: 100%;
    display: flex;
    justify-content: space-around;
    padding: 3% 0%;
    background-color: white;
    z-index: 1;
}

.button-container button{
    width: 44%;
}

.x{
    width: 20px;
    cursor: pointer;
}

@media screen and (min-width: 768px){
    .filters-page{
        justify-content: flex-start;
    }

    .filters-page-container{
        width: 20%;
    }

    .filters-container .product-sort{
        display: none;
    }
}
</style>